import React from 'react'
import classNames from 'classnames'

import css from './TextLink.styles.scss'

import { TextLinkProps } from './TextLink.types'

const TextLink: React.FC<TextLinkProps> = ({
  variant = 'default',
  size = 'md',
  disabled = false,
  className,
  innerContentClassName,
  children,
  icon,
  underline = false,
  weight = 'medium',
  onClick = () => {},
  ...props
}) => {
  const TextLinkClasses = classNames(
    css.TextLink,
    css[`text_link--size-${size}-${weight}`],
    css[`text_link--style-${variant}`],
    disabled && css['text_link--disabled'],
    className
  )

  return (
    <a
      className={TextLinkClasses}
      aria-disabled={disabled}
      onClick={(e) => {
        e.currentTarget.blur()
        onClick(e)
      }}
      {...props}
    >
      {icon?.side === 'left' && icon.icon}
      <div
        className={classNames(
          css.text_link__label,
          underline && css['text_link__label--underline'],
          innerContentClassName
        )}
      >
        {children}
      </div>
      {icon?.side === 'right' && icon.icon}
    </a>
  )
}

export default TextLink
